import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoginService } from './login.service';

@Injectable({
    providedIn: 'root'
})
export class ScoreService {
    private apiUrl: string;

    constructor(
        private http: HttpClient,
        private loginService: LoginService
    ) {
        this.apiUrl = environment.API_BACK;
    }

    private getLang(): string {
        return sessionStorage.getItem('lang') || 'es';
    }

    private handleError(error: HttpErrorResponse) {
        console.error('[ScoreService] Error en la petición:', error);

        if (error.status === 401) {
            this.loginService.logout();
            return throwError(() => new Error('Sesión expirada o inválida'));
        }

        return throwError(() => new Error(error.message || 'Error en el servidor'));
    }

    /**
     * Obtiene la actividad de puntos del cliente
     * @returns Observable con el historial de puntos
     */
    public getScoreActivity(clientId: string): Observable<any> {
        console.debug('[ScoreService] Obteniendo actividad de puntos para cliente:', clientId);
        const url = `${this.apiUrl}score/list?idclient=${clientId}&lang=${this.getLang()}`;

        return this.http.get(url, {
            headers: this.loginService.getHeaders(true)
        }).pipe(
            map(response => {
                console.debug('[ScoreService] Respuesta actividad:', response);
                return response;
            }),
            catchError(error => this.handleError(error))
        );
    }

    /**
     * Actualiza los puntos del cliente obteniendo su información más reciente
     * @returns Observable con la información actualizada del cliente
     */
    public refreshScore(): Observable<any> {
        console.debug('[ScoreService] Actualizando puntos del cliente');
        const url = `${this.apiUrl}client/view`;

        return this.http.get(url, {
            headers: this.loginService.getHeaders(true)
        }).pipe(
            map(response => {
                console.debug('[ScoreService] Respuesta actualización:', response);
                return response;
            }),
            catchError(error => this.handleError(error))
        );
    }
}
